import { render, staticRenderFns } from "./newSotreWarning.vue?vue&type=template&id=9fb638f6&scoped=true&"
import script from "./newSotreWarning.vue?vue&type=script&lang=js&"
export * from "./newSotreWarning.vue?vue&type=script&lang=js&"
import style0 from "./newSotreWarning.vue?vue&type=style&index=0&id=9fb638f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb638f6",
  null
  
)

export default component.exports